class EditWorkOrder implements MerchantosEditWorkOrder {
  serialized_id: MerchantosEditWorkOrder['serialized_id'];

  // @ts-expect-error ts-migrate(2564) FIXME: Property 'key_press_timer' has no initializer and ... Remove this comment to see the full error message
  key_press_timer: MerchantosEditWorkOrder['key_press_timer'];

  constructor() {
    this.serialized_id = 0;
  }

  /**
   * Key press event on a field that dynamically updates the results, makes sure that we only send an update if the user has paused 1000ms between keystrokes
   *
   * @return true
   */
  keyPressUpdateStatus: MerchantosEditWorkOrder['keyPressUpdateStatus'] = input => {
    if (this.key_press_timer) {
      clearTimeout(this.key_press_timer);
    }
    this.key_press_timer = window.setTimeout(
      () => window.merchantos.edit_workorder.updateStatusFieldTrigger(input),
      1000
    );
    return true;
  };

  /**
   * Update the dynamic customer search area with by searching on the customer fields that have been filled in
   *
   * @return true if an update is done, false if no update is done - because an update was done recently - in that case an update is scheduled
   */
  updateStatusFieldTrigger: MerchantosEditWorkOrder['updateStatusFieldTrigger'] = input => {
    if (this.key_press_timer) {
      clearTimeout(this.key_press_timer);
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'undefined' is not assignable to type 'number... Remove this comment to see the full error message
      this.key_press_timer = undefined;
    }
    return this.statusFieldChange(input);
  };

  /**
   * See if the edit_workorder_view hidden input is defined, if it is then we are not within the register, we are in a view
   *
   * @return true
   */
  isWithinView: MerchantosEditWorkOrder['isWithinView'] = () => {
    const within_view = $<HTMLInputElement>('#edit_workorder_view')[0];
    if (!within_view || within_view.value !== 'On') {
      return false;
    }
    return true;
  };

  /**
   * Check the id value that is defined in templates/edit_workorder/toolbar.tpl
   *
   * @return workorder id
   */
  getWorkorderID: MerchantosEditWorkOrder['getWorkorderID'] = () => {
    let id = 0;
    const $input = $('#edit_workorder_workorder_id');
    if ($input.length) {
      id = $input.val() as number;
    }
    return id;
  };

  /**
   * Grab the pannel_id that is defined in templates/edit_workorder/custom_view_tabs.tpl
   *
   * @return true
   */
  getPannelID: MerchantosEditWorkOrder['getPannelID'] = () => {
    const pannel_id_input = $<HTMLInputElement>('#edit_workorder_pannel_id')[0];
    if (pannel_id_input) {
      return pannel_id_input.value;
    }
  };

  /**
   * Open the item view for a new item that will then be added to the workorder
   *
   * @return true
   */
  newItem: MerchantosEditWorkOrder['newItem'] = () => {
    if (this.isWithinView()) {
      // we are on the view we need to go to the item view for a new item as a request, the view function below will do that
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | void' is not assignable... Remove this comment to see the full error message
      window.doViewFunction(this.getPannelID(), 'add_new_item_fnc');
      return true;
    }
    window.navigateToContent('view', 'item.views.register_workorder_item');
    return true;
  };

  /**
   * Open a URL with workorder parameters filled, hits a script that redirects to URL with parameters filled.
   *
   * @param {string} url The URL to open (parameters will be appended)
   * @param {string} target The target (e.g. '_blank')
   *
   * @return true
   */
  openURL: MerchantosEditWorkOrder['openURL'] = (url, target) => {
    url = `/register.php?form_name=workorder_open_url&url=${encodeURIComponent(
      url
    )}&workorder_id=${this.getWorkorderID()}`;

    window.merchantos.utils.openUrl(url, target);
  };

  /**
   * Attach a customer to the workorder
   *
   * @param integer customer_id The customer record id to attach
   * @return true
   */
  attachCustomer: MerchantosEditWorkOrder['attachCustomer'] = customer_id => {
    if (this.isWithinView()) {
      // we are on the view so do the view function
      // to have that work we need to set a field that the view save even will pickup
      $('#edit_workorder_customer_id').val(customer_id);
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | void' is not assignable... Remove this comment to see the full error message
      window.doViewFunction(this.getPannelID(), 'save');
      return true;
    }
  };

  /**
   * Open the customer view so user can edit the customer
   *
   * @param integer customer_id The customer record id to edit
   * @return true
   */
  editCustomer: MerchantosEditWorkOrder['editCustomer'] = customer_id => {
    if (this.isWithinView()) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | void' is not assignable... Remove this comment to see the full error message
      window.newView(this.getPannelID(), 'customer.views.customer', customer_id);
      return true;
    }
    window.navigateToContent('view', 'customer.views.customer', customer_id);
    return true;
  };

  /**
   * Open the transaction view / used to view the sale the workorder was completed on
   *
   * @param integer transaction_id The customer record id to edit
   * @return true
   */
  viewTransaction: MerchantosEditWorkOrder['viewTransaction'] = transaction_id => {
    if (this.isWithinView()) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | void' is not assignable... Remove this comment to see the full error message
      window.newView(this.getPannelID(), 'transaction.views.transaction', transaction_id);
      return true;
    }
    window.navigateToContent('view', 'transaction.views.transaction', transaction_id);
    return true;
  };

  /**
   * Open the serialized view so user can edit the serialized record, this is for the serialized item attached to the workorder record
   *
   * @param integer serialized_id The customer record id to edit
   * @return true
   */
  editSerializedItem: MerchantosEditWorkOrder['editSerializedItem'] = serialized_id => {
    if (serialized_id === 0 && this.serialized_id > 0) {
      serialized_id = this.serialized_id;
    }
    if (!serialized_id || serialized_id <= 0) {
      return false;
    }
    if (this.isWithinView()) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | void' is not assignable... Remove this comment to see the full error message
      window.newView(this.getPannelID(), 'item.views.serialized', serialized_id);
      return true;
    }
    window.navigateToContent('view', 'item.views.serialized', serialized_id);
    return true;
  };

  /**
   * Remove the customer from the workorder
   *
   * @return true
   */
  removeCustomer: MerchantosEditWorkOrder['removeCustomer'] = () => {
    // we call the view function, it's defined in gui_defs/workorder/views/beta_workorder class
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | void' is not assignable... Remove this comment to see the full error message
    window.doViewFunction(this.getPannelID(), 'remove_customer');
    return true;
  };

  /**
   * Open serialized view for serial numbers attached to workorder_item records
   *
   * @param integer serialized_id The serialized record id to edit
   * @return true
   */
  editSerialized: MerchantosEditWorkOrder['editSerialized'] = serialized_id => {
    if (this.isWithinView()) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | void' is not assignable... Remove this comment to see the full error message
      window.newView(this.getPannelID(), 'item.views.serialized', serialized_id);
      return true;
    }
    window.navigateToContent('view', 'item.views.serialized', serialized_id);
    return true;
  };

  /**
   * Open serialized view
   *
   * @param integer serialized_id The serialized record id to edit
   * @return true
   */
  removeSerialized: MerchantosEditWorkOrder['removeSerialized'] = (
    workorder_item_id,
    serialized_id
  ) => {
    const contentMap = {} as ContentMap;
    contentMap.form_name = 'edit_workorder.remove_serialized';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_item_id' does not exist on typ... Remove this comment to see the full error message
    contentMap.workorder_item_id = workorder_item_id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'serialized_id' does not exist on type 'C... Remove this comment to see the full error message
    contentMap.serialized_id = serialized_id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_id' does not exist on type 'Co... Remove this comment to see the full error message
    contentMap.workorder_id = this.getWorkorderID();
    window.doServerCall(contentMap, result =>
      window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
    );
    return true;
  };

  /**
   * Open serialized view
   *
   * @param integer serialized_id The serialized record id to edit
   * @return true
   */
  addSerialized: MerchantosEditWorkOrder['addSerialized'] = (workorder_item_id, serialized_id) => {
    const contentMap = {} as ContentMap;
    contentMap.form_name = 'edit_workorder.add_serialized';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_item_id' does not exist on typ... Remove this comment to see the full error message
    contentMap.workorder_item_id = workorder_item_id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'serialized_id' does not exist on type 'C... Remove this comment to see the full error message
    contentMap.serialized_id = serialized_id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_id' does not exist on type 'Co... Remove this comment to see the full error message
    contentMap.workorder_id = this.getWorkorderID();

    window.doServerCall(contentMap, result =>
      window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
    );
    return true;
  };

  /**
   * Open serialized view
   *
   * @param integer serialized_id The serialized record id to edit
   * @return true
   */
  addNewSerialized: MerchantosEditWorkOrder['addNewSerialized'] = (
    workorder_item_id,
    serial,
    color,
    size
  ) => {
    const contentMap = {} as ContentMap;
    contentMap.form_name = 'edit_workorder.add_new_serialized';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_item_id' does not exist on typ... Remove this comment to see the full error message
    contentMap.workorder_item_id = workorder_item_id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'serial' does not exist on type 'ContentM... Remove this comment to see the full error message
    contentMap.serial = serial;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'color' does not exist on type 'ContentMa... Remove this comment to see the full error message
    contentMap.color = color;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'size' does not exist on type 'ContentMap... Remove this comment to see the full error message
    contentMap.size = size;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_id' does not exist on type 'Co... Remove this comment to see the full error message
    contentMap.workorder_id = this.getWorkorderID();

    window.doServerCall(contentMap, result =>
      window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
    );
    return true;
  };

  /**
   * Open the item view. Different method of opening depending if we are on register or in a workorder view
   *
   * @param integer item_id The item id to edit
   * @return true
   */
  editItem: MerchantosEditWorkOrder['editItem'] = item_id => {
    if (this.isWithinView()) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | void' is not assignable... Remove this comment to see the full error message
      window.newView(this.getPannelID(), 'item.views.item', item_id);
    } else {
      window.navigateToContent('view', 'item.views.item', item_id);
    }
    return true;
  };

  /**
   * Add an item to the transaction
   *
   * @param integer item_id The item id to add
   * @return true
   */
  addUserItem: MerchantosEditWorkOrder['addUserItem'] = item_id => {
    const contentMap = {} as ContentMap;
    contentMap.form_name = 'edit_workorder.add_user_item';
    contentMap.item_id = item_id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_id' does not exist on type 'Co... Remove this comment to see the full error message
    contentMap.workorder_id = this.getWorkorderID();

    window.doServerCall(contentMap, result =>
      window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
    );
    return true;
  };

  /**
   * Import and add a vendor item to a workorder
   *
   * @param integer item_id The item id to add
   * @return true
   */
  importAddVendorItem: MerchantosEditWorkOrder['importAddVendorItem'] = item_vendor_item_id => {
    const contentMap = {} as ContentMap;
    contentMap.form_name = 'edit_workorder.import_add_vendor_item';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'item_vendor_item_id' does not exist on t... Remove this comment to see the full error message
    contentMap.item_vendor_item_id = item_vendor_item_id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_id' does not exist on type 'Co... Remove this comment to see the full error message
    contentMap.workorder_id = this.getWorkorderID();

    window.doServerCall(contentMap, result =>
      window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
    );
    return true;
  };

  /**
   * Add multiple items to the transaction
   *
   * @param string item_ids Comma separated list of item_ids to add
   * @param string quantities Optional: Comma separated list of quantities to add, correlates with item_ids
   * @return true
   */
  addMultipleUserItems: MerchantosEditWorkOrder['addMultipleUserItems'] = (
    item_ids,
    quantities
  ) => {
    const contentMap = {} as ContentMap;
    contentMap.form_name = 'edit_workorder.add_multiple_user_items';
    contentMap.item_ids = item_ids;
    if (quantities) {
      contentMap.quantities = quantities;
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_id' does not exist on type 'Co... Remove this comment to see the full error message
    contentMap.workorder_id = this.getWorkorderID();

    window.doServerCall(contentMap, result =>
      window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
    );
    return true;
  };

  /**
   * Do a search for an item to add to the workorder
   *
   * @param {Element} input
   * @param {Element} button
   * @return true
   */
  addItemSearch: MerchantosEditWorkOrder['addItemSearch'] = (input, button) => {
    const form_name = 'edit_workorder.add_item_search';
    const contentMap = {
      form_name,
      add_search_item_text: input.value,
      workorder_id: this.getWorkorderID(),
    };

    if (this.isWithinView()) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'within_view' does not exist on type '{ f... Remove this comment to see the full error message
      contentMap.within_view = 'On';
    }
    const pannel_id = this.getPannelID();
    if (pannel_id) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'pannel_id' does not exist on type '{ for... Remove this comment to see the full error message
      contentMap.pannel_id = pannel_id;
    }

    const promise = window.doServerCall(contentMap, result =>
      window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
    );

    input.value = '';

    // Track multiple clicks & visually disable button
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    window.merchantos.sidebar.xhrStarted(form_name, button, promise);

    return true;
  };

  /**
   * Save a change to a status field (status, employee, shop, item, note etc.
   *
   * @param Object type The form input that has changed
   * @return true
   */
  statusFieldChange: MerchantosEditWorkOrder['statusFieldChange'] = input => {
    const contentMap = {} as ContentMap;
    contentMap.form_name = 'edit_workorder.save_satus_field_change';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_id' does not exist on type 'Co... Remove this comment to see the full error message
    contentMap.workorder_id = this.getWorkorderID();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'field_name' does not exist on type 'Cont... Remove this comment to see the full error message
    contentMap.field_name = input.name;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'field_value' does not exist on type 'Con... Remove this comment to see the full error message
    contentMap.field_value = window.getFormFieldValue(input);

    // When creating a new workorder from the register (ALT+K)
    // no workorder_id is assigned at first, solves CLD-13543
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_id' does not exist on type 'Co... Remove this comment to see the full error message
    if (!contentMap.workorder_id) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'field_name' does not exist on type 'Cont... Remove this comment to see the full error message
      if (contentMap.field_name !== 'time_in') {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        const time_in = document.getElementById('workorder_edit_time_in_field').value;
        if (time_in) {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'time_in' does not exist on type 'Content... Remove this comment to see the full error message
          contentMap.time_in = time_in;
        }
      }
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'field_name' does not exist on type 'Cont... Remove this comment to see the full error message
      if (contentMap.field_name !== 'eta_out') {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        const eta_out = document.getElementById('workorder_edit_time_out_field').value;
        if (eta_out) {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'eta_out' does not exist on type 'Content... Remove this comment to see the full error message
          contentMap.eta_out = eta_out;
        }
      }
    }

    if (this.isWithinView()) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'within_view' does not exist on type 'Con... Remove this comment to see the full error message
      contentMap.within_view = 'On';
    }
    window.doServerCall(contentMap, result =>
      window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
    );
    return true;
  };

  /**
   * Opens an inline form below the register control bar to fill in details for adding different line types
   *
   * @param string type The type/name of the form to get
   * @return true
   */
  getAddExpander: MerchantosEditWorkOrder['getAddExpander'] = type => {
    const contentMap = {} as ContentMap;
    contentMap.form_name = `edit_workorder.add_expander.${type}`;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_id' does not exist on type 'Co... Remove this comment to see the full error message
    contentMap.workorder_id = this.getWorkorderID();

    window.doServerCall(contentMap, result =>
      window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
    );
    return true;
  };

  /**
   * Submit inline form for processing
   *
   * @param string type The type/name of the form to get
   * @param object obj The button object
   * @return true
   */
  submitAddExpander: MerchantosEditWorkOrder['submitAddExpander'] = (type, obj) => {
    if (this.validateSaveAddExpander(type)) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLButtonElement' is not assign... Remove this comment to see the full error message
      if (!window.merchantos.controls.prevent_repeat.preventIt(obj)) {
        this.saveAddExpander(type);
      }
    }
    return false;
  };

  /**
   * Save the inline form that expands below the control bar - adds a line to the sale/customer/workorder with specified details
   *
   * @param string type The type/name of the form to get
   * @return true
   */
  saveAddExpander: MerchantosEditWorkOrder['saveAddExpander'] = type => {
    const add_expander = $('#add_expander_holder')[0];

    if (add_expander) {
      const contentMap = {} as ContentMap;
      contentMap.form_name = `edit_workorder.add_expander.save_${type}`;
      contentMap.values = window.toJsonString(window.getFormValues('add_expander'));
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_id' does not exist on type 'Co... Remove this comment to see the full error message
      contentMap.workorder_id = this.getWorkorderID();
      window.doServerCall(contentMap, result =>
        window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
      );
    }
    return true;
  };

  /**
   * SaveAddExpander data validation
   *
   * @param string type The type/name of the form to validate
   * @return true/false
   */
  validateSaveAddExpander: MerchantosEditWorkOrder['validateSaveAddExpander'] = type => {
    const contentMap = {} as ContentMap;
    contentMap.values = window.getFormValues('add_expander');

    let msg = '';
    switch (type) {
      case 'add_labor':
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'note' does not exist on type '{} | { [ke... Remove this comment to see the full error message
        if (window.merchantos.form_validation.isEmpty(contentMap.values.note)) {
          msg = 'Labor charge description cannot be empty';
          $('#add_labor_description').trigger('focus');
        }
        break;
      case 'add_misc':
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'note' does not exist on type '{} | { [ke... Remove this comment to see the full error message
        if (window.merchantos.form_validation.isEmpty(contentMap.values.note)) {
          msg = 'Miscellaneous charge description cannot be empty';
          $('#add_misc_description').trigger('focus');
        }
        break;
      default:
        msg = 'Save validation called with an unrecognized type.';
        break;
    }

    if (msg) {
      window.showNotifier('warning', msg);
      return false;
    }
    return true;
  };

  /**
   * Opens an inline form below the sales/refund/layaway/special order/workorder line to edit that line's info
   *
   * @param string type The type/name of the form to get
   * @param number id The id of the record for the line
   * @param number line_id The id of line html
   * @return true
   */
  inlineEditLine: MerchantosEditWorkOrder['inlineEditLine'] = (type, id, line_id, set_focus) => {
    const contentMap = {} as ContentMap;
    contentMap.form_name = `edit_workorder.inline_edit.${type}`;
    contentMap.id = id;
    contentMap.line_id = line_id;

    if (set_focus) {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'true' is not assignable to type 'string | un... Remove this comment to see the full error message
      contentMap.set_focus = set_focus;
    }

    window.doServerCall(contentMap, result =>
      window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
    );
    return true;
  };

  /**
   * Submit inline form for processing.
   *
   * @param object obj Button object
   * @param string type The type/name of the form to save
   * @param number id The id of the object that is being saved
   * @param number line_id The id of the transaction_line we are editing (same as id except for edit workorder stuff)
   * @param number item_id The Item ID if this is a item transaction line
   * @return true
   */
  submitInlineEditLine: MerchantosEditWorkOrder['submitInlineEditLine'] = (
    _obj,
    type,
    id,
    line_id,
    item_id
  ) => {
    if (item_id > 0 || (!item_id && this.validateInLineEditLine(type, id))) {
      this.saveInlineEditLine(type, id, line_id);
    }
  };

  /**
   * Validate for Misc and Labor charge, the note is not blank
   *
   * @param string type process name
   * @param number id The id of the object that is being saved
   * @returns true if note present / false if note blank
   */
  validateInLineEditLine: MerchantosEditWorkOrder['validateInLineEditLine'] = (type, id) => {
    const contentMap = {} as ContentMap;
    contentMap.values = window.getFormValues(`${type}_${id}`);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'note' does not exist on type '{} | { [ke... Remove this comment to see the full error message
    if (window.merchantos.form_validation.isEmpty(contentMap.values.note)) {
      window.showNotifier('warning', 'Miscellaneous or Labor charge description cannot be empty');
      $(`#inline_edit_note_${id}`).trigger('focus');
      return false;
    }
    return true;
  };

  /**
   * Save the inline form to edit the sales/refund/layaway/special order/workorder line
   *
   * @param string type The type/name of the form to save
   * @param number id The id of the object that is being saved
   * @param number line_id The id of the transaction_line we are editing (same as id except for edit workorder stuff)
   * @return true
   */
  saveInlineEditLine: MerchantosEditWorkOrder['saveInlineEditLine'] = (type, id, line_id) => {
    const add_expander = $(`#${type}_${id}`)[0];
    if (add_expander) {
      const contentMap = {} as ContentMap;
      contentMap.form_name = `edit_workorder.inline_edit.save_${type}`;
      contentMap.id = id;
      contentMap.line_id = line_id;
      contentMap.values = window.toJsonString(window.getFormValues(`${type}_${id}`));
      window.doServerCall(contentMap, result =>
        window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
      );
    }
    return true;
  };

  /**
   * Cancel the inline form to edit the sales/refund/layaway/special order/workorder line, restore the normal line
   *
   * @param number line_id The id of the transaction_line that is being edited
   * @return true
   */
  cancelInlineEditLine: MerchantosEditWorkOrder['cancelInlineEditLine'] = line_id => {
    $(`#line_${line_id}_1`).show();
    $(`#line_${line_id}_2`).show();
    $(`#line_${line_id}_3`).show();
    $(`#line_${line_id}_4`).show();
    $(`#line_${line_id}_5`).show();
    $(`#line_${line_id}_edit`).hide();
    return true;
  };

  /**
   * Delete a line from a workorder
   *
   * @param number line_id The ID of the transaction_line to remove
   * @return true
   */
  removeLine: MerchantosEditWorkOrder['removeLine'] = (line_id, line_type) => {
    const removeConfirmed = this.confirmRemoval(line_type);

    if (!removeConfirmed) {
      return;
    }

    const contentMap = {} as ContentMap;
    contentMap.form_name = 'edit_workorder.remove_line';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_line_id' does not exist on typ... Remove this comment to see the full error message
    contentMap.workorder_line_id = line_id;
    window.doServerCall(contentMap, result =>
      window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
    );
  };

  /**
   * Delete a line from a workorder
   *
   * @param number line_id The ID of the transaction_line to remove
   * @return true
   */
  removeItem: MerchantosEditWorkOrder['removeItem'] = (line_id, line_type) => {
    const removeConfirmed = this.confirmRemoval(line_type);

    if (!removeConfirmed) {
      return;
    }

    const contentMap = {} as ContentMap;
    contentMap.form_name = 'edit_workorder.remove_item';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_item_id' does not exist on typ... Remove this comment to see the full error message
    contentMap.workorder_item_id = line_id;
    window.doServerCall(contentMap, result =>
      window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
    );
  };

  /**
   * Confirm the removal of a WO line.
   *
   * @param line_type {string} - The type of line being removed
   * @return boolean
   */
  confirmRemoval: MerchantosEditWorkOrder['confirmRemoval'] = line_type => {
    let confirm_message = 'Are you sure you want to ';

    switch (line_type) {
      case 'item':
        confirm_message += 'delete this item from the work order?';
        break;
      case 'special_order':
        confirm_message += 'delete this special order item?';
        break;
      case 'labor':
        confirm_message += 'remove this labor charge?';
        break;
      default:
        confirm_message += 'remove this line?';
    }

    confirm_message += '\n\nThis action cannot be undone.';

    // eslint-disable-next-line no-alert
    return window.confirm(confirm_message);
  };

  /**
   * Internally used to remove the actual HTML for a transaction/workorder line
   *
   * @param number line_id The ID of the transaction_line to remove
   * @return true
   */
  remove_line_html: MerchantosEditWorkOrder['remove_line_html'] = line_id => {
    const existing_line1 = $(`#line_${line_id}_1`)[0];
    const existing_line2 = $(`#line_${line_id}_2`)[0];
    const existing_line3 = $(`#line_${line_id}_3`)[0];
    const existing_line4 = $(`#line_${line_id}_4`)[0];
    const existing_line5 = $(`#line_${line_id}_5`)[0];
    const existing_line_edit = $(`#line_${line_id}_edit`)[0];
    if (existing_line1) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      existing_line1.parentNode.removeChild(existing_line1);
    }
    if (existing_line2) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      existing_line2.parentNode.removeChild(existing_line2);
    }
    if (existing_line3) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      existing_line3.parentNode.removeChild(existing_line3);
    }
    if (existing_line4) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      existing_line4.parentNode.removeChild(existing_line4);
    }
    if (existing_line5) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      existing_line5.parentNode.removeChild(existing_line5);
    }
    if (existing_line_edit) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      existing_line_edit.parentNode.removeChild(existing_line_edit);
    }
  };

  /**
   * Internally used to add or replace the HTML of a line item
   *
   * @param number table The DOM Node that is table or tbody that the add/replace will be done on
   * @param number line_id The ID of the transaction_line to remove
   * @param number new_html The HTML to use as the new line
   * @return true
   */
  add_or_replace_line_html: MerchantosEditWorkOrder['add_or_replace_line_html'] = (
    table,
    line_id,
    new_html
  ) => {
    const innerhtml_table = document.createElement('table');
    innerhtml_table.innerHTML = new_html;

    const fragment = document.createDocumentFragment();

    let innerhtml_tbody: HTMLTableElement;
    let child;
    for (let y = 0; y < innerhtml_table.childNodes.length; y++) {
      child = innerhtml_table.childNodes[y];
      if (child.nodeName.toLowerCase() == 'tbody') {
        // @ts-expect-error ts-migrate(2740) FIXME: Type 'ChildNode' is missing the following properti... Remove this comment to see the full error message
        innerhtml_tbody = child;
      }
    }
    // @ts-expect-error ts-migrate(2454) FIXME: Variable 'innerhtml_tbody' is used before being as... Remove this comment to see the full error message
    if (!innerhtml_tbody) {
      // this is for safari and any other browser that doesn't create a tbody within the table automatically
      innerhtml_tbody = innerhtml_table;
    }

    for (let x = 0; x < innerhtml_tbody.childNodes.length; x++) {
      child = innerhtml_tbody.childNodes[x];
      if (child.nodeName.toLowerCase() !== 'tr') {
        continue;
      }
      innerhtml_tbody.removeChild(child);
      fragment.appendChild(child);
    }

    let replace_done = false;

    const existing_line1 = $(`#line_${line_id}_1`)[0];
    const existing_line2 = $(`#line_${line_id}_2`)[0];
    const existing_line3 = $(`#line_${line_id}_3`)[0];
    const existing_line4 = $(`#line_${line_id}_4`)[0];
    const existing_line5 = $(`#line_${line_id}_5`)[0];
    const existing_line_edit = $(`#line_${line_id}_edit`)[0];
    if (existing_line3) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      existing_line3.parentNode.replaceChild(fragment, existing_line3);
      replace_done = true;
    }
    if (existing_line1) {
      if (replace_done) {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        existing_line1.parentNode.removeChild(existing_line1);
      } else {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        existing_line1.parentNode.replaceChild(fragment, existing_line1);
        replace_done = true;
      }
    }
    if (existing_line2) {
      if (replace_done) {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        existing_line2.parentNode.removeChild(existing_line2);
      } else {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        existing_line2.parentNode.replaceChild(fragment, existing_line2);
        replace_done = true;
      }
    }
    if (existing_line4) {
      if (replace_done) {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        existing_line4.parentNode.removeChild(existing_line4);
      } else {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        existing_line4.parentNode.replaceChild(fragment, existing_line4);
        replace_done = true;
      }
    }
    if (existing_line5) {
      if (replace_done) {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        existing_line5.parentNode.removeChild(existing_line5);
      } else {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        existing_line5.parentNode.replaceChild(fragment, existing_line5);
        replace_done = true;
      }
    }
    if (existing_line_edit) {
      if (replace_done) {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        existing_line_edit.parentNode.removeChild(existing_line_edit);
      } else {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        existing_line_edit.parentNode.replaceChild(fragment, existing_line_edit);
        replace_done = true;
      }
    }

    if (!replace_done) {
      // not found we need to add it
      if (table.firstChild) {
        table.insertBefore(fragment, table.firstChild);
        return;
      }
      table.appendChild(fragment);
    }
  };

  /**
   * Save edits done directly on the sale line editable fields
   *
   * @param string type The form processor handler to use to save the edit (in includes/forms/ajax_forms/direct_edit/save_<type>.php)
   * @param string field The name of the field on the line that is being edited (field should be in the form of "<tablename>.<fieldname>")
   * @param number id The id of the object that is being edited
   * @param string line_id The id of the transaction_line that is being edited (same as id param except for edit_workorder stuff)
   * @param mixed new_value The new value to save in the object field
   * @return true
   */
  saveDirectEdit: MerchantosEditWorkOrder['saveDirectEdit'] = (
    type,
    field,
    id,
    line_id,
    new_value
  ) => {
    const contentMap = {} as ContentMap;
    contentMap.form_name = `edit_workorder.direct_edit.save_${type}`;
    contentMap.field = field;
    contentMap.id = id;
    contentMap.line_id = line_id;
    contentMap.new_value = new_value;
    window.doServerCall(contentMap, result =>
      window.merchantos.edit_workorder.ajaxEditWorkorder_Return(result)
    );
  };

  /**
   * Function called by .bind after ajax response is received
   *
   * @param array result the array of result fields
   */
  ajaxEditWorkorder_Return: MerchantosEditWorkOrder['ajaxEditWorkorder_Return'] = result => {
    // little bit of a dungeon hack here
    if (this.isWithinView()) {
      // if we are on a view and there are hidden register version of workorders then remove them
      // their id's might conflict with ours and create weird behaviour (like innerHTMLs getting filled in on hidden workorder)
      // instead of the view
      // $('#non_ajax_content').html('');
    } else {
      // same as above but remove view edit workorder html if we are on the register
      $('#view_edit_workorder').html('');
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'serialized_id' does not exist on type 'P... Remove this comment to see the full error message
    if (result.serialized_id) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'serialized_id' does not exist on type 'P... Remove this comment to see the full error message
      this.serialized_id = result.serialized_id;
    }

    if (result.workorder_id) {
      // push id value into the workorder_id field in case getWorkOrderID() is called before the dom is updated.
      const $input = $('#edit_workorder_workorder_id');
      if ($input.length) {
        $input.val(result.workorder_id);
      }
    }

    if (result.close_add_expander) {
      $('#add_expander_holder').hide();
    }

    if (result.add_expander) {
      $('#add_expander_holder')
        .show()
        .htmlReplace(result.add_expander);

      if (result.set_focus) {
        window.merchantos.focus.set(result.set_focus);
      }
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'customer_serial_change' does not exist o... Remove this comment to see the full error message
    if (result.customer_serial_change) {
      // @ts-expect-error ts-migrate(2551) FIXME: Property 'serial_description' does not exist on ty... Remove this comment to see the full error message
      $('#serial_description').val(result.serial_description);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'serial_is_item' does not exist on type '... Remove this comment to see the full error message
      if (result.serial_is_item) {
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        $('#serial_description').attr('disabled', true);
      } else {
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        $('#serial_description').attr('disabled', false);
      }
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'serial_color' does not exist on type 'Pa... Remove this comment to see the full error message
      $('#serial_color').val(result.serial_color);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'serial_size' does not exist on type 'Par... Remove this comment to see the full error message
      $('#serial_size').val(result.serial_size);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'serial_serial' does not exist on type 'P... Remove this comment to see the full error message
      $('#serial_serial').val(result.serial_serial);
    }
    if (result.inline_edit) {
      const existing_line_edit = $(`#line_${result.line_id}_edit`)[0];
      const existing_line_edit_inner = $(`#line_${result.line_id}_edit_inner`)[0];
      if (existing_line_edit && existing_line_edit_inner) {
        existing_line_edit.style.display = '';
        existing_line_edit_inner.innerHTML = result.inline_edit;

        $(`#line_${result.line_id}_1`).hide();
        $(`#line_${result.line_id}_2`).hide();
        $(`#line_${result.line_id}_3`).hide();
        $(`#line_${result.line_id}_4`).hide();
        $(`#line_${result.line_id}_5`).hide();

        if (result.set_focus) {
          window.merchantos.focus.set(result.set_focus);
        }
      }
    }
    if (result.remove_line) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
      this.remove_line_html(result.line_id);
    }
    let lines_table;
    if (result.add_line) {
      // get the lines table
      lines_table = $(`#${result.line_type}`)[0];
      if (!lines_table) {
        window.alertUser('Could not add line.');
        return;
      }
      // add the line or replace it
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement' is not assignable t... Remove this comment to see the full error message
      this.add_or_replace_line_html(lines_table, result.line_id, result.add_line_html);

      // enable the all lines buttons
      $('#all_lines_functions').show();

      if (result.set_focus) {
        window.merchantos.focus.set(result.set_focus);
      }
    }
    if (result.add_multiple_lines) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      for (let i = 0; i < result.lines.length; i++) {
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        const line = result.lines[i];

        // get the lines table
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'line_type' does not exist on type 'Line'... Remove this comment to see the full error message
        lines_table = $(`#${line.line_type}`)[0];
        if (!lines_table) {
          window.alertUser('Could not add lines.');
          return;
        }

        // if the line exists remove it
        this.remove_line_html(line.line_id);
        // add the line
        lines_table.innerHTML = line.add_line_html + lines_table.innerHTML;
      }

      // enable the all lines buttons
      $('#all_lines_functions').show();

      if (result.set_focus) {
        window.merchantos.focus.set(result.set_focus);
      }
    }
    if (result.special_total) {
      // replace any special totals
      $(`#${result.special_total}`).htmlReplace(result.special_total_html);
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_status_color' does not exist o... Remove this comment to see the full error message
    if (result.workorder_status_color) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_status_color' does not exist o... Remove this comment to see the full error message
      $('#workorder_status_wrapper').css('border-color', result.workorder_status_color);
      $('#workorder_status_flag h2')
        .addClass('notranslate')
        .htmlReplace($('#workorder_edit_status_field option:selected').text());
    }
    if (result.listing) {
      window.merchantos.display.init();
      window.merchantos.display.hideListingsViews();
      window.merchantos.display.recordDisplay();
      window.merchantos.focus.record('add_search_item_text');
      const init_search = [
        ['description', result.search_description],
        ['workorder_id', result.workorder_id],
      ];
      if (result.results_tab) {
        window.navigateToContent('listing', result.listing, init_search, result.results_tab);
      } else {
        window.navigateToContent('listing', result.listing, init_search);
      }
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_html' does not exist on type '... Remove this comment to see the full error message
    if (result.workorder_html) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'workorder_html' does not exist on type '... Remove this comment to see the full error message
      $('#edit_workorder_wrapper').htmlReplace(result.workorder_html);
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'register_tab' does not exist on type 'Pa... Remove this comment to see the full error message
    if (result.register_tab) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'register_tab' does not exist on type 'Pa... Remove this comment to see the full error message
      $('#edit_workorder_register_tab').htmlReplace(result.register_tab);
    }

    if (result.html) {
      if (result.replace_lines) {
        // display content that replace the man sales lines (and other tabs) part of the register, leaves the customer name and totals
        // like the item edit dialog would do this
        // todo add an id to that part of the HTML so it can be replaced
      } else {
        window.merchantos.display.replaceNonAjax(result.html);
      }
      if (result.set_focus) {
        window.merchantos.focus.set(result.set_focus);
      }
    }

    // see if we need to edit a line price
    if (result.edit_line) {
      window.merchantos.edit_workorder.inlineEditLine(
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'edit_line_type' does not exist on type '... Remove this comment to see the full error message
        result.edit_line_type,
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
        result.edit_line_id,
        result.edit_line_line_id,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'edit_line_focus' does not exist on type ... Remove this comment to see the full error message
        result.edit_line_focus
      );
    }

    if (this.isWithinView()) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | void' is not assignable... Remove this comment to see the full error message
      window.finishAjaxRequest(this.getPannelID(), result);
    }
  };
}

window.merchantos.edit_workorder = new EditWorkOrder();
